'use client';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { fadeIn } from '@/lib/animations';
import { MapPin } from 'lucide-react';
import { Button } from './components/ui/button';

export function About() {
	const [ref, inView] = useInView({
		triggerOnce: true,
		threshold: 0.05,
		rootMargin: '200px 0px',
	});

	return (
		<section id="about" className="py-24 bg-gray-50">
			<div className="container mx-auto px-4 md:px-6">
				<div className="grid md:grid-cols-2 gap-12 items-center">
					<motion.div
						ref={ref}
						initial="hidden"
						animate={inView ? 'show' : 'hidden'}
						variants={fadeIn('right')}
						className="relative"
					>
						<div className="absolute -top-4 -left-4 w-24 h-24 bg-brand-600 rounded-tl-2xl"></div>
						<img
							src="https://lindner-marketing.s3.eu-west-2.amazonaws.com/outside.png"
							alt="Lindner Logistics facility"
							className="rounded-lg shadow-xl relative z-10 w-full h-[400px] object-cover"
						/>
						<div className="absolute -bottom-4 -right-4 w-32 h-32 bg-brand-100 rounded-br-2xl"></div>
					</motion.div>

					<motion.div
						ref={ref}
						initial="hidden"
						animate={inView ? 'show' : 'hidden'}
						variants={fadeIn('left')}
					>
						<h2 className="text-sm font-semibold text-brand-600 uppercase tracking-wider mb-2">
							About Us
						</h2>
						<h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
							Wisconsin's Most Trusted Logistics Partner
						</h3>

						<p className="text-gray-700 mb-6">
							In the competitive landscape of e-commerce and distribution, partnering
							with a reliable third-party logistics (3PL) provider is crucial. Lindner
							Logistics offers tailored 3PL services in Wisconsin, designed to improve
							efficiency, reduce costs, and support your business growth.
						</p>

						<p className="text-gray-700 mb-8">
							With strategically located facilities and a team of logistics experts,
							we provide end-to-end solutions tailored to your specific needs, from
							warehousing and distribution to transportation management and beyond.
						</p>

						<div className="flex flex-wrap gap-4 mb-8">
							<div className="flex items-center">
								<MapPin className="text-brand-600 mr-2" />
								<span className="text-gray-700">Milwaukee 6th Street</span>
							</div>
							<div className="flex items-center">
								<MapPin className="text-brand-600 mr-2" />
								<span className="text-gray-700">Bayview</span>
							</div>
							<div className="flex items-center">
								<MapPin className="text-brand-600 mr-2" />
								<span className="text-gray-700">Waukesha</span>
							</div>
							<div className="flex items-center">
								<MapPin className="text-brand-600 mr-2" />
								<span className="text-gray-700">Milwaukee 20th Street</span>
							</div>
						</div>

						<Button className="bg-brand-600 hover:bg-brand-700 text-white">
							Our Locations
						</Button>
					</motion.div>
				</div>
			</div>
		</section>
	);
}
